function formatLocalDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** 브라우저 로컬 기준 오늘 (YYYY-MM-DD) */
export function todayLocalDate(): string {
  return formatLocalDate(new Date());
}

/** 이번 달 1일 (YYYY-MM-DD) */
export function monthStartLocalDate(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}

/** 오늘부터 N일 후 (YYYY-MM-DD) */
export function daysFromTodayLocalDate(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return formatLocalDate(d);
}

/** 조달 송장·출고조회 기본 기간: 이번 달 1일 ~ 오늘+7일 */
export function procurementDefaultDateRange(): { start: string; end: string } {
  return {
    start: monthStartLocalDate(),
    end: daysFromTodayLocalDate(7),
  };
}

/** API/PostgreSQL 날짜·일시 값을 로컬 기준 YYYY-MM-DD로 변환 */
export function toDateOnlyString(value: unknown): string {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) return formatLocalDate(d);
    return value.slice(0, 10);
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return formatLocalDate(value);
  }
  return String(value).slice(0, 10);
}

/** 요일 짧은 표기 (월, 화, …) */
export function getKoreanDayShort(dateStr: string): string {
  const parts = dateStr.trim().split('-').map(Number);
  if (parts.length !== 3 || parts.some(n => Number.isNaN(n))) return '';
  const date = new Date(parts[0], parts[1] - 1, parts[2]);
  return date.toLocaleDateString('ko-KR', { weekday: 'short' });
}

/** 배차일보·정산일보 요일 색상 */
export function getKoreanDayColor(dayKor: string): string {
  const map: Record<string, string> = {
    월: '#ff9800',
    화: '#388e3c',
    수: '#00bcd4',
    목: '#7b1fa2',
    금: '#d32f2f',
    토: '#795548',
    일: '#f44336',
  };
  return map[dayKor] || '#1976d2';
}
